import React, { useState, useCallback } from 'react';
import './CardImage.css';

/**
 * Image with loading placeholder (skeleton). Shows a shimmer placeholder until the image loads, then fades in.
 * Use wrapperClassName to size the container; img will fill it via object-fit: cover.
 */
export default function CardImage({ src, alt = '', className = '', wrapperClassName = '', loading = 'lazy', referrerPolicy = 'no-referrer' }) {
  const [loaded, setLoaded] = useState(false);
  const onLoad = useCallback(() => setLoaded(true), []);

  if (!src) return null;

  return (
    <div className={`card-image-wrap ${wrapperClassName}`.trim()}>
      {!loaded && <div className="card-image-skeleton" aria-hidden="true" />}
      <img
        src={src}
        alt={alt}
        loading={loading}
        referrerPolicy={referrerPolicy}
        onLoad={onLoad}
        className={`card-image-img ${className}`.trim()}
        style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.2s ease-in' }}
      />
    </div>
  );
}
